import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import "./style.scss";
import { Link } from "react-router-dom";
import AuthLayout from "../../../components/authlayout";
import { toast } from "react-toastify";

const Forgotpassword = () => {
  const history = useNavigate()
  const [form, setForm] = useState({ email: "" })

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      history("/dashboard")
    }
  }, [])

  const hendleSubmit = (e: any) => {
    e.preventDefault()
    loader(true)
    ApiClient.post("user/forgot/password", form).then((res) => {
      if (res.success) {
        toast.success(res.message)
        history("/login")
        loader(false)
      } else {
        loader(false)
        toast?.error(res?.message)
      }
    })
  }

  return (
    <>
      <AuthLayout>
        <form className="" onSubmit={hendleSubmit}>
          <div className="text-center">
            <h1 className="text-[24px] font-semibold text-black">
              Forgot Passowrd
            </h1>
            <span className="flex mx-auto w-10 h-1 bg-[#F58D18] mt-1"></span>
          </div>
          <p className="text-[18px] text-center font-normal text-[#222] mt-4">
            {" "}
            No worries! Just enter your email and we’ll send you a reset
            password link.
          </p>
          <div className=" mt-5">
            <div className="inputWrapper">
              <input
                type="email"
                className="mb-4 w-full text-sm text-[#222]  h-16 p-3 flex items-center gap-2 overflow-hidden bg-transparent border border-[#D9D9D9] rounded-[14px]"
                placeholder="Email*"
                value={form.email}
                required
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
          </div>

          <div className="flex items-center justify-center mt-6">
            <button
              type="submit"
              className="h-11 rounded-[10px] w-full font-semibold text-center text-white   hover:opacity-80 transition-all"
            >
              Send Recovery Email
            </button>
          </div>

          <p className="text-[#222] text-center font-normal text-[14px] mt-4">
            {" "}
            Just Remember?
            <Link
              className="text-[#F58D18] text-[14px] !font-semibold"
              to="/login"
            >
              {" "}
              Sign In
            </Link>
          </p>
        </form>
      </AuthLayout>
    </>
  );
};

export default Forgotpassword;
